import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "col-xl-12 col-lg-12" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = {
    class: "col-12 col-sm-6 my-4",
    valign: "top"
};
const _hoisted_4 = { class: "col-12 col-sm-6" };
const _hoisted_5 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_opening_times_block = _resolveComponent("opening-times-block");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.location.name), 1),
                _createElementVNode("h5", null, "Enfernung: ~ " + _toDisplayString(_ctx.location.distance) + " km", 1),
                _createElementVNode("p", null, [
                    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.location.zip_code), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.location.city), 1)
                ]),
                _createVNode(_component_opening_times_block, { opening_times: _ctx.openingTimes }, null, 8, ["opening_times"]),
                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "m-0" }, "Ankaufskategorien:", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.location.active_red_categories, (category) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: `category-${category.id}`
                    }, [
                        _createElementVNode("span", null, _toDisplayString(category.name), 1)
                    ]));
                }), 128))
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("iframe", {
                    width: "100%",
                    height: "430",
                    src: _ctx.link,
                    allowfullscreen: ""
                }, null, 8, _hoisted_5)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "clearfix" }, null, -1))
        ])
    ]));
}
